export default __webpack_public_path__ + "static/media/0x6286a9e6f7e745a6d884561d88f94542d6715698.ee23a095.webp";